import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

type Props = {
    className?: string;
    imageUrl: string;
    title: string;
};

export const ImageComponent = ({ className, imageUrl, title }: Props) => {
    return (
        <div className={cn('relative mx-auto aspect-[3/2] w-full max-w-[588px]', className)}>
            <img
                alt={title}
                aria-label={title}
                className="h-full w-full rounded-md object-cover"
                src={imageUrl}
                title={title}
            />
        </div>
    );
};
